import defaultImagePortrait from '@/assets/campgrounds-integration/creekPortrait.jpg';
import defaultImageLandscape from '@/assets/campgrounds-integration/fall-lake.jpg';
import defaultImageLandscape2 from '@/assets/campgrounds-integration/lake.jpg';
import { ISimpleImage } from '@/components/route/campground/campgroundTypes';

const defaultImages: ISimpleImage[] = [
  {
    alt: 'default_image_1',
    credits: '',
    description: '',
    subtitle: '',
    title: '',
    url: defaultImageLandscape.src,
    id: '',
  },
  {
    alt: 'default_image_2',
    credits: '',
    description: '',
    subtitle: '',
    title: '',
    url: defaultImageLandscape2.src,
    id: '',
  },
  {
    alt: 'default_image_3',
    credits: '',
    description: '',
    subtitle: '',
    title: '',
    url: defaultImagePortrait.src,
    id: '',
  },
];

export default defaultImages;
